import { v4 as uuidv4 } from "uuid";
import { splitRange, columnToIndex, isCell, isRange, rowToIndex, getRangesFromAString } from "../utils/util";
function splitFormula(title, texts, currentSheetName) {
  currentSheetName = currentSheetName.toUpperCase();
  const cellsOrRanges = getRangesFromAString(title);
  const arr = [];
  let startPosition = 0;

  cellsOrRanges.forEach((item) => {
    const firstRangePosition = title.indexOf(item, startPosition);

    // Extract the text before the current range or cell reference
    const nonRangeElement = title.substring(startPosition, firstRangePosition);
    startPosition = firstRangePosition + item.length;

    // Determine if the item is a range or normal text
    let isRangeItem =
      isRange(item.replace(`${currentSheetName}!`, "")) || isCell(item.replace(`${currentSheetName}!`, ""));

    // Check if the item starts with the current sheet name and validate the rest
    if (!isRangeItem && item.startsWith(`${currentSheetName}!`)) {
      const strippedItem = item.replace(`${currentSheetName}!`, "");
      isRangeItem = isRange(strippedItem);
    }

    const text = texts[item] ?? item;

    // Push the non-range part as a "normal" element, if any
    if (nonRangeElement) {
      arr.push({
        id: uuidv4(),
        range: nonRangeElement,
        type: "normal",
        text: nonRangeElement,
      });
    }

    // Push the current item as "range" or "normal"
    arr.push({
      id: uuidv4(),
      range: item.replace(`${currentSheetName}!`, ""),
      type: isRangeItem ? "range" : "normal",
      text: text,
    });
  });

  // If there's remaining text after the last range/cell reference, add it as normal text
  if (title.length > startPosition) {
    const remainingText = title.substring(startPosition, title.length);
    arr.push({
      id: uuidv4(),
      range: remainingText,
      type: "normal",
      text: remainingText,
    });
  }

  return arr;
}
class RangeSelection {
  ranges = [];
  activeRangeId = "";
  splittedFormula = [];
  constructor() {}

  setRanges(title, texts, currentSheetName) {
    this.splittedFormula = splitFormula(title, texts, currentSheetName);
    this.setRefinedRanges();
  }
  updateRange(range, id, mode, text) {
    if (!id) id = this.activeRangeId;
    this.splittedFormula = this.splittedFormula.map((item) =>
      item.id === id
        ? {
            ...item,
            range,
            mode: mode,
            text: text ?? range,
          }
        : item
    );

    this.setRefinedRanges();
  }
  getFormula() {
    const text = this.splittedFormula.reduce((acc, item) => acc + item.text, "");
    return text.substring(text.indexOf("=")).trim();
  }
  resetRanges() {
    this.splittedFormula = [];
    this.ranges = [];
    this.activeRangeId = "";
  }
  getRanges() {
    return this.ranges.map((item) => {
      const range = splitRange(item.range);
      range[0] = columnToIndex(range[0]);
      range[1] = rowToIndex(range[1]);
      range[2] = columnToIndex(range[2]);
      range[3] = rowToIndex(range[3]);

      return {
        id: item.id,
        range,
        mode: item.mode,
        text: item.text,
      };
    });
  }
  setRefinedRanges() {
    this.ranges = this.splittedFormula
      .filter((item) => item.type === "range")
      .map((item) => (isCell(item.range) ? { ...item, range: `${item.range}:${item.range}` } : item));
  }
  setActiveRangeId(rangeId) {
    this.activeRangeId = rangeId;
  }
}
export default RangeSelection;
